import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  standalone: false,
  name: 'chatConversationTimePipe'
})
export class ChatConversationTimePipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService) {
  }

  transform(date: any): unknown {
    let today = new Date();
    let yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    let copiedDate = new Date(date.getTime());
    copiedDate.setHours(0,0,0,0)

    if (copiedDate.setHours(0,0,0,0) == today.setHours(0,0,0,0)) {
      var hours = date.getHours();
      var minutes = date.getMinutes();

      if (hours < 10) {
        hours = `0${hours}`
      }

      if (minutes < 10) {
        minutes = `0${minutes}`
      }

      return `${hours}:${minutes}`;
    } else if (copiedDate.setHours(0,0,0,0) == yesterday.setHours(0,0,0,0)) {
      return this.translateService.instant('Yesterday');
    } else {
      return date.toLocaleDateString("IL");
    }
  }

}
